import React, { useState, useEffect } from "react";
import { getApiCall, postApiCall, patchApiCall } from "../../../service/httpCall";
import { Row, Col, Card, Form } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  API_FLASH_MESSAGE_LIST,
  API_FLASH_MESSAGE_EDIT
} from "../../../service/url";
import { ROUTES } from "../../../utilities/constant";
import Loader  from '../../../components/partials/components/loader';
import { useNavigate } from "react-router-dom";
import { USER_ROLES, MODULE_ACL } from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { getUser } from "../../../utilities/setting";
import { Button } from 'primereact/button';
import "../../../assets/custom/css/custom.css";
import exportData from '../../../utilities/export';
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";

const FlashMessageList = () => {
  const navigate = useNavigate();
  const [flashMessageList, setFlashMessageList] = useState([]);
  const [originalDataList, setOriginalDataList] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [isSuperAdmin, checkIsSuperAdmin] = useState(false);
  const [loggedInUserACL, setLoggedInUserACL] = useState({})
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [updating, setUpdating] = useState(false);

  const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "flash-message-list",
         data: flashMessageList,
         columns: [
            {
               header: "Id",
               accessor: "id"
            },
            {
               header: "Module Name",
               accessor: "module_name"
            },
            {
               header: "Action Name",
               accessor: "action"
            },
            {
               header: "Type",
               accessor: "type"
            },
            {
               header: "Priority(Notes)",
               accessor: "priority"
            },
            {
               header: "Created Date",
               accessor: (row) =>
                  new Date(row.created_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            },
            {
               header: "Message",
               accessor: (row) =>
                  row.message || "-"
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};
 
  const fetchFlashMessage = async () => {
    setLoading(true);
    try {
      getApiCall(API_FLASH_MESSAGE_LIST)
        .then(onFlashMessageSuccess)
        .catch(onError)
        .finally(() => setLoading(false));
    } catch (error) {
      console.error("Error fetching Flash Message:", error);
      setLoading(false);
    }
  };

   useEffect(() => {
      const user = getUser();
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
        if (user?.role === USER_ROLES.SUPERADMIN) {
          checkIsSuperAdmin(true);
        }
    fetchFlashMessage();
   }, []);


  function onFlashMessageSuccess(resp) {
    setFlashMessageList(resp);
    setOriginalDataList(resp);
  }

  const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
  
    useEffect(() => {
      const user = getUser();
        if (user) {
          if (user?.acl_settings) {    
            setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
          }
        }
    }, []);

  useEffect(() => {
      if(searchValue){
        setFlashMessageList(
          originalDataList.filter((data) => data.module_name.toLowerCase().includes(searchValue.trim().toLowerCase()))
        );
      }
      else {
        setFlashMessageList(originalDataList);
      }
  }, [searchValue]);
 
  function onError(err) {
     console.log(err)
 }

 const handleCreateButtonClick = () => {
  navigate(`/${ROUTES.FLASH_MESSAGE.CREATE}`);
} 

  if (loading) {
    return <Loader />
 }

  const handleViewMessage = (rowData) => {
    console.log("Opening modal for row:", rowData);

    setSelectedId(rowData.id);
    setSelectedMessage(rowData.message);
    setIsEditMode(false);
    setViewModalVisible(true);
  };

  const handleUpdateMessage = async () => {
    try {
      setUpdating(true);

      const payload = {
        message: selectedMessage,
      };

      await postApiCall(`${API_FLASH_MESSAGE_EDIT}/${selectedId}`, payload);
      toast.success('Message Updated Successfully');
      setViewModalVisible(false);
      setIsEditMode(false);
      fetchFlashMessage();

    } catch (error) {
      toast.warning(error);
      console.error("Error updating message:", error);
    } finally {
      setUpdating(false);
    }
  };


  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">Flash Message List</h4>
              </div>
              {(isSuperAdmin || loggedInUserACL[MODULE_ACL.FLASH_MESSAGE]?.add) && (
                <button className="btn btn-primary ml-auto" onClick={handleCreateButtonClick}>
                  Create Flash Message
                </button>
              )}

            </Card.Header>
              <Card.Body className="px-0">
                <div className="table-responsive border-bottom my-3">
                <div style={{display: "flex", alignItems: "flex-start", justifyContent: "flex-start"}}>
                  {flashMessageList.length > 0 && 
                  <Button 
                     label="Export Data" 
                    onClick={handleExport} 
                    className="p-button-active p-button-sm" 
                    style={{ marginBottom: '10px', marginLeft: '10px' }} 
                    disabled={buttonDisable} 
                     >
                    &nbsp;
                   {buttonDisable && (
                   <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                   )}
                  </Button>
                  }

                  <Form.Group style={{height: "45px"}}>
                    <Form.Control
                      style={{height: "50px", marginLeft: "10px", border: "1px solid #ced4da", fontSize: "15px", height: "45px"}}
                      placeholder = 'Search by Module Name...'
                      type="text"
                      maxLength={100}
                      value={searchValue} 
                      onChange={(e) => setSearchValue(e.target.value)}
                      required
                    />
                  </Form.Group>
                  </div>
                  <div className="scroll-container">
                    <DataTable
                      value={flashMessageList}
                      tableStyle={{ minWidth: "50rem" }}
                      paginator
                      rows={8}
                    >
                      <Column
                        field="id"
                        header="Id"
                      />
                      <Column
                        field="module_name"
                        header="Module Name"
                      />
                      <Column
                        field="action"
                        header="Action Name"
                      />
                      <Column
                        field="type"
                        header="Type"
                      />
                      <Column
                        field="priority"
                        header="Priority(Notes)"
                      />
                      <Column field="req_date" header="Created Date" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                      }></Column>
                      <Column
                        header="Message"
                        body={(rowData) => {
                          return (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center"
                              }}
                            >
                              <button
                                type="button"
                                onClick={() => handleViewMessage(rowData)}
                                style={{
                                  background: "transparent",
                                  border: "1px solid #007bff",
                                  color: "#007bff",
                                  padding: "4px 12px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  fontSize: "14px"
                                }}
                              >
                                View
                              </button>
                            </div>
                          );
                        }}
                        style={{ width: "10rem", textAlign: "center" }}
                      />
                    </DataTable>
                  </div>  
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <Dialog
        header="Flash Message"
        visible={viewModalVisible}
        style={{ width: "40vw" }}
        onHide={() => {
          setViewModalVisible(false);
          setIsEditMode(false);
        }}
        footer={
          isEditMode ? (
            <div>
              <Button
                label="Cancel"
                className="p-button-text"
                onClick={() => setIsEditMode(false)}
              />
              <Button
                label={updating ? "Updating..." : "Update"}
                onClick={handleUpdateMessage}
                disabled={updating}
              />
            </div>
          ) : null
        }
      >
        <div style={{ marginBottom: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          
        {!isEditMode && (
          <FaEdit
            style={{
              cursor: "pointer",
              fontSize: "18px",
              color: "#007bff"
            }}
            onClick={() => setIsEditMode(true)}
            title="Edit Message"
          />
        )}
        </div>

        <InputTextarea
          value={selectedMessage}
          onChange={(e) => setSelectedMessage(e.target.value)}
          rows={5}
          cols={40}
          autoResize
          disabled={!isEditMode}
          style={{ width: "100%" }}
        />
      </Dialog>

    </>
  );
};

export default FlashMessageList;